/* Doll Crochet: small behaviours for the header menu, gallery, bundles and reviews. */
(function () {
  var burger = document.querySelector('[data-sm-burger]');
  var mnav = document.getElementById('sm-mnav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.hasAttribute('hidden');
      if (open) mnav.removeAttribute('hidden'); else mnav.setAttribute('hidden', '');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var track = document.querySelector('[data-sm-track]');
  if (track) {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-sm-thumb]'));
    var count = track.children.length;
    var smooth = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    var current = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var paintThumbs = function () {
      var i = current();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
    };
    var go = function (i) {
      if (i < 0) i = count - 1;
      if (i >= count) i = 0;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth });
    };
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = document.querySelector('[data-sm-prev]');
    var next = document.querySelector('[data-sm-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
    });
    var timer;
    track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(paintThumbs, 80); });
  }

  document.querySelectorAll('[data-sm-bundle]').forEach(function (box) {
    var radios = box.querySelectorAll('input[type="radio"]');
    function paint() {
      radios.forEach(function (r) { r.closest('.sm-tier').classList.toggle('is-on', r.checked); });
    }
    if (radios.length && !box.querySelector('input:checked')) radios[0].checked = true;
    radios.forEach(function (r) { r.addEventListener('change', paint); });
    paint();
    var btn = box.querySelector('[data-sm-bundle-add]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var picked = box.querySelector('input:checked');
      if (!picked) return;
      var items = picked.value.split(',').filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
      btn.disabled = true;
      fetch(box.getAttribute('data-add-url') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        window.location.href = box.getAttribute('data-cart-url');
      }).catch(function () { btn.disabled = false; });
    });
  });

  var reviews = document.querySelector('[data-sm-reviews]');
  var rating = document.querySelector('[data-sm-rating]');
  if (reviews && rating && Number(reviews.getAttribute('data-live')) > 0) {
    var stars = reviews.querySelector('[data-sm-sumstars]');
    var count = reviews.getAttribute('data-count');
    rating.innerHTML = (stars ? stars.innerHTML : '') + '<span></span>';
    rating.querySelector('span').textContent = reviews.getAttribute('data-rating') + ' · ' + count + (count === '1' ? ' review' : ' reviews');
    rating.removeAttribute('hidden');
  }
  var more = document.querySelector('[data-sm-more]');
  if (more) {
    more.addEventListener('click', function () {
      document.querySelectorAll('.sm-rev__card.is-hidden').forEach(function (c) { c.classList.remove('is-hidden'); });
      more.remove();
    });
  }
})();
